// import { ListResponseModel } from ".";
// import { ProductCategory } from "../model/appliance";
import { SolarProduct } from "../model/solar-product/solar-product";
import { apiSlice } from "../stores/base/api-slice";

const wishlistEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getWishlists: builder.query<Array<SolarProduct>, void>({
			providesTags: ["Wishlist"],
			query: () => ({
				url: "/wishlist/products",
				method: "GET",
			}),
		}),
		createWishlist: builder.mutation<any, string>({
			invalidatesTags: ["Wishlist", "SolarProducts"],
			query: id => ({
				url: "/wishlist/products",
				method: "POST",
				body: { solarProductId: id },
			}),
		}),
		deleteAllWihslist: builder.mutation<any, void>({
			invalidatesTags: ["Wishlist"],
			query: () => ({
				url: "/wishlist/products",
				method: "DELETE",
			}),
		}),
		deleteWishlistItem: builder.mutation<any, string>({
			invalidatesTags: ["Wishlist", "SolarProducts"],
			query: id => ({
				url: `/wishlist/products/${id}`,
				method: "DELETE",
			}),
		}),
	}),
});

export const { useLazyGetWishlistsQuery, useCreateWishlistMutation, useDeleteWishlistItemMutation, useDeleteAllWihslistMutation } = wishlistEndpoints;
